import FlatPriceEditor from "./FlatPriceEditor";

export default FlatPriceEditor;
